import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Permission from "@/pcm/store/models/Permission";

export default class Role extends Model {
    static entity = 'roles';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            name: this.string(''),
            permissions: this.attr([]),

            created_at: this.string(''),
            updated_at: this.string(''),
        }
    }

    declare id: number;
    declare name: string;
    declare permissions: Array<Permission>;
}
